import { StatusCell } from './StatusCell';
import { StyledTable } from './StatusTable.styled';

interface StatusTableProps {
  communityId: number;
  communityName: string;
  communityUrl: string;
  mediaFilesStatus: string;
  userRemovalStatus: string;
  communityDataStatus: string;
  communityMetadataStatus: string;
  overallStatus: string;
  resetButtonClick: () => void;
}

export const StatusTable = ({
  communityId,
  communityName,
  communityUrl,
  mediaFilesStatus,
  userRemovalStatus,
  communityDataStatus,
  communityMetadataStatus,
  overallStatus,
  resetButtonClick
}: StatusTableProps) => {
  const stepStatuses = [mediaFilesStatus, userRemovalStatus, communityDataStatus, communityMetadataStatus];
  const noStepFails = stepStatuses.every((status) => status !== 'Fail');
  const showOverallStatusReset = overallStatus === 'Fail' && noStepFails;

  const dataTable = {
    caption: 'Community remove process details',
    body: [
      { cells: [{ children: 'Community Id' }, { children: communityId }] },
      { cells: [{ children: 'Community Name' }, { children: communityName }] },
      { cells: [{ children: 'Community Url' }, { children: communityUrl }] },
      {
        cells: [
          { children: 'Remove Media Files' },
          { children: <StatusCell status={mediaFilesStatus} resetButtonClick={resetButtonClick} /> }
        ]
      },
      {
        cells: [
          { children: 'Remove Users' },
          { children: <StatusCell status={userRemovalStatus} resetButtonClick={resetButtonClick} /> }
        ]
      },
      {
        cells: [
          { children: 'Remove Community Content Data' },
          { children: <StatusCell status={communityDataStatus} resetButtonClick={resetButtonClick} /> }
        ]
      },
      {
        cells: [
          { children: 'Remove Community Metadata' },
          { children: <StatusCell status={communityMetadataStatus} resetButtonClick={resetButtonClick} /> }
        ]
      },
      {
        cells: [
          { children: 'Overall Status' },
          {
            children: (
              <StatusCell
                status={overallStatus}
                resetButtonClick={resetButtonClick}
                showOverallStatusReset={showOverallStatusReset}
              />
            )
          }
        ]
      }
    ]
  };

  return <StyledTable data={dataTable} data-testid="status-table" />;
};
